module.exports = "<template> <div id=sio-dashboard class=container-fluid></div> </template>";